import styled from "styled-components";
import * as MUI from "@mui/material";

import color from "../../../../constants/color";

export const SectionContent = styled.div`
  width: 100%;
`;

export const ContentContainer = styled.div`
  padding: 0px 32px 32px;
  display: flex;
  justify-content: space-between;
`;

export const HorizontalAccordionContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

export const ModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  height: 70%;
  box-shadow: 24;
  border-radius: 8px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
`;

export const ModalHeader = styled.div`
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  height: 400px;
  box-shadow: 24;
  border-radius: 8px 8px 0px 0px;
`;

export const Accordion = styled(MUI.Accordion)`
  width: calc(20% - 20px);
  width: 550px;
  border-radius: 16px;
  border: 1px solid #ececec;
`;

export const AccordionSummary = styled(MUI.AccordionSummary)`
  cursor: pointer;
`;

export const AccordionDetails = styled(MUI.AccordionDetails)`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  width: 100%;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-family: "Inter";
  font-size: 18px;
  font-weight: 500;
  line-height: 21.78px;
`;

export const NoArchieve = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
  line-height: 21.78px;
`;

export const NoFolders = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
  line-height: 21.78px;
`;

export const TableContainer = styled.table`
  width: 100%;
  border: 1px solid #d5d5d5;
  border-radius: 16px;
  margin-top: 20px;
  border-collapse: separate !important;
  .nome {
    margin-left: 10px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    direction: ltr;
  }
  .tipo {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .acoes {
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 8px;
  }
`;

export const ShortcutsTitle = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.01em;
  color: ${color.fullBlack};
  margin-bottom: 32px;
  z-index: 1;
  position: relative;
`;

export const Shortcuts = styled.div`
  position: relative;
  padding: 0px 32px;
`;

export const TableHeader = styled.thead`
  color: #929292;
  font-size: 14px;
  tr {
    padding: 16px;
    display: flex;
    text-align: left;
    justify-content: space-between;
    border-bottom: 1px solid #d5d5d5;
    font-family: "Inter";
    font-size: 16px;
    font-weight: 500;
    line-height: 21.78px;
  }

  th {
    width: 30%;
    font-family: "Inter";
    font-size: 16px;
    font-weight: 500;
    line-height: 21.78px;
  }
`;

export const TableBody = styled.tbody`
  width: 100%;
`;

export const TableCell = styled.tr`
  width: 100%;
  max-width: 510px;
  display: flex;
  justify-content: space-between;
  td {
    width: 30%;
    padding: 26px 8px;
    text-align: left;
    display: flex;
    align-items: center;
    font-family: "Inter";
    font-size: 16px;
    font-weight: 500;
    line-height: 21.78px;
  }
`;

export const Button = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
`;
